import React from "react";
import { Modal } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import styles from "./DeleteAddendumModal.module.scss";

const SCOPE_WORDS = {
  episode: "episódios",
  chapter: "capítulos",
};

const SCOPE_ITEM_LABEL = {
  episode: "Episódio",
  chapter: "Capítulo",
};

export const DeleteAddendumModal = ({
  open,
  scope = "chapter",
  associations = [],
  onClose = () => {},
  onConfirm = () => {},
}) => {
  const scopeWord = SCOPE_WORDS[scope] ?? SCOPE_WORDS.chapter;
  const itemLabel = SCOPE_ITEM_LABEL[scope] ?? SCOPE_ITEM_LABEL.chapter;

  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.container}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.headerTitle}>
            <WarningAmberRoundedIcon className={styles.warningIcon} />
            <span className={styles.title}>Excluir arquivo</span>
          </div>
          <CloseIcon onClick={onClose} className={styles.closeIcon} />
        </div>

        {/* Body */}
        <div className={styles.body}>
          <p className={styles.attention}>ATENÇÃO</p>

          <p className={styles.message}>
            {`Este arquivo está associado a outros ${scopeWord}. Se você removê-lo, ele será desassociado de todos os outros locais.`}
          </p>

          <ul className={styles.list}>
            {associations.map((item) => (
              <li
                key={`${item.scope}-${item.number}`}
                className={`${styles.listItem} ${
                  item.isCurrent ? styles.current : ""
                }`}
              >
                {`${SCOPE_ITEM_LABEL[item.scope] ?? itemLabel} ${item.number}`}
              </li>
            ))}
          </ul>
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <button
            type="button"
            className={`${styles.button} ${styles.cancelButton}`}
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={`${styles.button} ${styles.confirmButton}`}
            onClick={onConfirm}
          >
            <DeleteOutlineIcon className={styles.buttonIcon} />
            Remover arquivo e associações
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAddendumModal;
